import React from 'react';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { useTranslation } from 'react-i18next';
import styles from './footer.module.scss';
import SocialLinks from '../../common/SocialLinks/SocialLinks';
import BottomLinks from '../../common/BottomLinks/BottomLinks';
import CookieButton from '../../hubspotButton/CookieButton';

export function Footer() {
  const [t] = useTranslation();
  const privacyLabel = 'common.footer.privacy';
  const supportLabel = 'common.footer.support';
  return (
    <footer className={`${styles.footer} py-2`}>
      <div className={styles.containerFluid}>
        <div className={`col d-flex align-items-center ${styles.stackedContent}`}>
          {/* <BottomLinks
                url="#"
                label="SITEMAP"
              /> .  */}
          <CookieButton className="sidebar" /> . .{' '}
          <BottomLinks url="https://www.airswift.com/privacy-cookie-policy/" label={t(privacyLabel)} />. .{' '}
          <BottomLinks url="https://sway.office.com/RWsRwruawTiI96Bl?ref=email/" label={t(supportLabel)} />. .{' '}
          <BottomLinks url="https://www.airswift.com/" label="AIRSWIFT ©" />
        </div>
        <div className={`col text-end ${styles.socialMobile}`}>
          <SocialLinks url="https://www.facebook.com/weareairswift" icon={<FacebookIcon fontSize="small" />} />
          <SocialLinks url="https://www.linkedin.com/company/airswift/" icon={<LinkedInIcon fontSize="small" />} />
          <SocialLinks url="https://www.twitter.com/weareairswift" icon={<TwitterIcon fontSize="small" />} />
          <SocialLinks
            url="https://www.youtube.com/channel/UC36v2qP1q2Gj-mXyGZ9czzQ/featured"
            icon={<YouTubeIcon fontSize="small" />}
          />
          <SocialLinks url="https://www.instagram.com/weareairswift" icon={<InstagramIcon fontSize="small" />} />
        </div>
      </div>
    </footer>
  );
}
